import { API } from "../../api.js";
import { $, esc } from "../../ui/format.js";
import { helpIcon } from "../../ui/help.js";

// ---------------------------------------------------------------- Global Economy (Macro)

const MACRO_PHASE_CLASS = {
  Overheating: "high", Tightening: "high", Slowdown: "med", Expansion: "low", Stable: "low",
};

async function renderMacro(main, snap) {
  main.innerHTML = `
    <div class="sx">
      <header class="sx-header"><div><h2 class="sx-title">The economy where you sell ${helpIcon("macro")}</h2>
        <p class="sx-sub">Month ${snap.month}. Growth, inflation, interest rates and confidence in every country you earn from, weighted by your revenue there.</p></div></header>
      <div class="plain-english-card" id="macro-plain-english">Loading…</div>
      <div id="macro-summary">Loading…</div>
      <section class="sx-card"><div class="sx-card-head"><div><h3 class="sx-card-title">By country</h3>
        <div class="sx-card-sub">The bar is that country's share of your revenue; the badge is where its economy is in the cycle.</div></div></div>
        <div id="macro-rows">Loading…</div></section>
    </div>`;

  const macro = await fetch(`${API}/macro-economy`).then((x) => x.json());
  const effect = macro.growth_effect_pct;
  const effectLabel = effect > 0.05 ? "tailwind" : effect < -0.05 ? "headwind" : "roughly neutral";
  const effectColor = effect > 0.05 ? "var(--sage)" : effect < -0.05 ? "var(--oxblood)" : "var(--text-mid)";

  $("macro-plain-english").innerHTML = `
    This month's blended macro effect on your growth is
    <strong style="color:${effectColor};">${effect > 0 ? "+" : ""}${effect}pt</strong> (${effectLabel}) —
    weighted by how much of your revenue comes from each country you operate in.
    ${macro.explanation.length ? macro.explanation.join(" ") : "No country is running far enough from its own baseline cycle to move your numbers meaningfully right now."}
  `;

  $("macro-summary").innerHTML = `
    <div class="sx-kpis">
      <div class="sx-kpi"><div class="sx-kpi-label">Effect on your growth</div><div class="sx-kpi-value" style="color:${effectColor};">${effect > 0 ? "+" : ""}${effect} pts</div><div class="sx-kpi-sub">a ${effectLabel} this month</div></div>
      <div class="sx-kpi"><div class="sx-kpi-label">Countries you earn in</div><div class="sx-kpi-value">${macro.countries.length}</div></div>
    </div>`;

  $("macro-rows").innerHTML = macro.countries.map((c) => `
    <div class="risk-row">
      <div class="risk-row-left">
        <div class="mc-share" aria-hidden="true"><i style="width:${Math.max(2, Math.min(100, c.revenue_weight_pct)).toFixed(1)}%"></i></div>
        <div class="risk-row-label">${esc(c.country)}${c.is_hq ? " (HQ)" : ""}</div>
        <div class="risk-row-sub">
          GDP growth ${c.gdp_growth_pct}% · inflation ${c.inflation_pct}% · policy rate ${c.interest_rate_pct}% ·
          unemployment ${c.unemployment_pct}% · consumer confidence ${c.consumer_confidence}/100 ·
          ${c.revenue_weight_pct}% of revenue
        </div>
      </div>
      <span class="flight-risk-badge ${MACRO_PHASE_CLASS[c.cycle_phase] || "low"}">${esc(c.cycle_phase)}</span>
    </div>
  `).join("");
}

export { renderMacro };
